import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Applicant } from '@app/models/recruiting/applicant.model';

@Component({
    selector: 'app-applicant-basic-information',
    templateUrl: './applicant-basic-information.component.html',
    styleUrls: ['./applicant-basic-information.component.scss'],
})
export class ApplicantBasicInformationComponent {
    @Input() applicant: Applicant;

    @Output()
    editClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

    handleEditClick(): void {
        this.editClicked.emit(true);
    }
}
